export default __webpack_public_path__ + "static/media/352.8f358729.png";